/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{ZEROS as o}from"../../../../core/libs/gl-matrix-2/factories/vec4f64.js";const r=1.2,t=o,c=4;export{c as labelMarginPx,r as suspendResumeExtentOptimism,t as transparentUnit};
